/* eslint-disable @typescript-eslint/no-use-before-define */
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { InventoryQuery } from '@euler/functions/useInventory';
import { InspectionReportItem } from '@euler/model/report';
import { memo } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { ImageStyle } from 'react-native-fast-image';
import { DashboardSiteItemCell } from './DashboardSiteItemCell';

export const DashboardSiteItemList = memo(
  ({
    items,
    inventoryQuery,
    style,
    itemStyle,
    ...props
  }: {
    items: InspectionReportItem[];
    iconSize?: number;
    iconStyle?: StyleProp<ImageStyle>;
    itemStyle?: StyleProp<ViewStyle>;
    labelStyle?: StyleProp<TextStyle>;
    statusBadgeStyle?: StyleProp<ViewStyle>;
    statusTextStyle?: StyleProp<TextStyle>;
    inventoryQuery: InventoryQuery;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();

    if (!items.length) return null;

    return (
      <View
        css={`
          padding: 0 ${rpx(15)}px;
          padding-bottom: ${rpx(10)}px;
        `}
        style={style}
      >
        {items.map((item, i) => (
          <DashboardSiteItemCell
            key={item.siteId}
            item={item}
            site={inventoryQuery.getSiteById(item.siteId!)}
            last={i === items.length - 1}
            style={itemStyle}
            {...props}
          />
        ))}
      </View>
    );
  },
);
